import data from "../../../../../src/Spinner/Spinner.docs.json";
import * as React from 'react';
export default {
  data,
  React
};